<img src="../../../../../assets/world animation gif.gif" alt="" class="image-loading-style">
<p class="info-text">Calculating carbon footprint based on provided parameters...</p>